import * as React from 'react';
import {GetContainer} from '../GetContainer';
import {useGetContainerShow} from '../GetContainer/GetContainer.enhancers';
import {IOuter} from './GetEntityMechanizedApp.types';

export const GetEntityMechanizedApp: React.FunctionComponent<IOuter> = () => {
  const getContainerShow = useGetContainerShow();
  if (!getContainerShow) {
    return null;
  }
  return <GetContainer getContainerShow={getContainerShow} />;
};

GetEntityMechanizedApp.displayName = 'GetEntityMechanizedApp';
